import { render, staticRenderFns } from "./start.vue?vue&type=template&id=66da4c33&scoped=true&"
import script from "./start.vue?vue&type=script&lang=js&"
export * from "./start.vue?vue&type=script&lang=js&"
import style0 from "./start.vue?vue&type=style&index=0&id=66da4c33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66da4c33",
  null
  
)

export default component.exports